var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page"},[(_vm.hasLogin&&_vm.showHeaderAndSideBar&&_vm.meta.fullscreen!==true)?_c('app-header'):_vm._e(),(_vm.hasLogin&&_vm.showHeaderAndSideBar&&_vm.meta.fullscreen!==true)?_c('side-bar'):_vm._e(),_c('app-content',[_c('router-view')],1)],1),_c('call-dialog',{ref:"call"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }